
<script>
export default {
  props: {
    issue: {
      type: String,
      default: "",
    },
  },
  render(h) {
    return h(
      "a",
      {
        attrs: {
          href: "https://atominc.atlassian.net/browse/" + this.issue,
          target: "_blank",
        },
      },
      this.issue
    );
  },
};
</script>